import { Image } from "@nextui-org/react";
import React from "react";
import { motion } from "framer-motion";
import { CardBody, CardContainer, CardItem } from "../../ui/3d-card";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const fadeInDown = {
  hidden: { opacity: 0, y: -50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const Unique = () => {
  return (
    <section className="container xl:px-[80px] lg:px-[60px] sm:px-10 min-w-full pt-[40px] lg:pb-[120px] md:pb-[80px] pb-[40px]">
      <motion.h2
        className="font-bold text-2xl sm:text-[30px] text-textColor text-center mx-auto max-w-[390px] md:mb-20 mb-10"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        What Makes the Travel Award Unique?
      </motion.h2>
      <div className="flex items-start lg:justify-between justify-center lg:flex-nowrap flex-wrap gap-x-20 gap-y-10">
        {[
          {
            img: "/images/travelAwards/unique1.png",
            title: "Diverse Categories",
            text: "Celebrating a range of travel mediums like blogs, photography, and social media.",
          },
          {
            img: "/images/travelAwards/unique2.png",
            title: "Global Reach",
            text: "Recognizing creators from every corner of the globe.",
          },
          {
            img: "/images/travelAwards/unique3.png",
            title: "Focus on Impact",
            text: "Highlighting content that inspires change, fosters inclusivity, and promotes sustainability.",
          },
        ].map((item, index) => (
          <motion.div
            key={index}
            className="lg:w-auto md:w-[44%] sm:w-[60%] w-[90%]"
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.2 }}
            variants={index === 1 ? fadeInDown : fadeInUp}
          >
            <CardContainer>
              <CardBody>
                {index !== 1 && (
                  <CardItem>
                    <Image
                      src={item.img}
                      alt={item.title}
                      className={"size-full rounded-lg"}
                      classNames={{ wrapper: "xl:w-[336px] xl:h-[246px] rounded-lg" }}
                    />
                  </CardItem>
                )}
                <CardItem>
                  <h4 className="font-extrabold text-xl mt-4 mb-2 text-textColor">
                    {item.title}
                  </h4>
                  <p className={`${index === 1 && "mb-6"} font-light max-w-[336px] text-textColor`}>{item.text}</p>
                </CardItem>
                {index === 1 && (
                  <CardItem>
                    <Image
                      src={item.img}
                      alt={item.title}
                      className={"size-full rounded-lg"}
                      classNames={{ wrapper: "xl:w-[336px] xl:h-[246px] rounded-lg" }}
                    />
                  </CardItem>
                )}
              </CardBody>
            </CardContainer>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Unique;
